export const Statuses = {
  IN_PROGRESS: 'in-progress',
  TIMEOUT: 'timeout',
  FAILURE: 'failure',
  SKIPPED: 'skipped',
  SUCCESS: 'success'
};